import { isEmpty, isArray, trim } from 'lodash';
import i18n from '@/js/vue-i18n';
import { toSentenceCase } from '../utils/string-utils';

const required = (value, message = toSentenceCase(i18n.t('validation.common.required'))) =>
    (isArray(value) ? !isEmpty(value) : !!trim(value)) || message;

export default required;
